export interface TipoVeiculoModel {
    name: string;
    descricao: string;
}

export const TIPOS_VEICULO: TipoVeiculoModel[] = [
    { name: "LEVE", descricao: "Leve" },
    { name: "UTILITARIO", descricao: "Utilitário" },
    { name: "PESADO", descricao: "Pesado" },
    { name: "ULTRA_PESADO", descricao: "Extra pesado" },
]